export default ({ request }) => ({
  fabricStockListApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/stock/list',
      method: 'post',
      data,
    })
  },
  fabricStockDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/stock/detail',
      method: 'post',
      data,
    })
  },
  fabricStockSetStorageApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/stock/setStorage',
      method: 'post',
      data,
    })
  },
  warehouseTreeApi(data = {}) {
    return request({
      url: '/digitalCenter/master/warehouse/treeList',
      method: 'post',
      data,
    })
  },
  fabricStockTurnoverApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/stock/turnover',
      method: 'post',
      data,
    })
  },
  fabricStockChoiceApi(data = {}) {
    return request({
      url: '/digitalCenter/fabric/stock/choice',
      method: 'post',
      data,
    })
  },
})
